import axios from 'axios';
import { toast } from 'react-toastify';

const API_BASE_URL = "https://ims.holdthechild.net/api";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to attach the auth token to all outgoing requests
apiClient.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, error => {
  return Promise.reject(error);
});

// Response interceptor to handle ALL API errors centrally
apiClient.interceptors.response.use(
  response => response, // Return the full response object, not just the data
  error => {
    let errorMessage = "An unknown error occurred.";

    if (error.response) {
      if (error.response.data && error.response.data.message) {
        errorMessage = error.response.data.message;
      } else if (error.response.statusText) {
        errorMessage = error.response.statusText;
      }
    } else if (error.request) {
      errorMessage = "No response from server. Please check your internet connection.";
    } else {
      errorMessage = error.message;
    }

    toast.error(errorMessage);
    
    return Promise.reject(error);
  }
);

// Functions for API calls, using the configured apiClient
export const createRequisition = (requisitionData) => apiClient.post('/requisitions', requisitionData);
export const getRequisitions = (filters = {}) => apiClient.get('/requisitions', { params: filters });
export const getRequisitionById = (id) => apiClient.get(`/requisitions/${id}`);
export const updateRequisition = (id, updateData) => apiClient.put(`/requisitions/${id}`, updateData);
export const deleteRequisition = (id) => apiClient.delete(`/requisitions/${id}`);
export const getProjectsForRequisition = () => apiClient.get('/projects');
export const approveRequisition = (id, comments = "") => apiClient.patch(`/requisitions/${id}/approve`, { comments });
export const rejectRequisition = (id, comments = "") => apiClient.patch(`/requisitions/${id}/reject`, { comments });